module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"preOrders":"Vorbestellungen {siteId}"},"en":{"preOrders":"Pre-orders {siteId}"}}')
  delete Component.options._Ctor
}
